function openTab(evt, tabName, tabWrapper) {
  const tabWrapperElement = document.getElementById(tabWrapper);

  // Hide all tab contents within the given tabWrapper
  const tabcontents = tabWrapperElement.querySelectorAll(
    '.main-product__tab-content'
  );
  tabcontents.forEach(content => {
    content.style.display = 'none';
  });

  // Remove 'active' class from all tab links within the given tabWrapper
  const tablinks = tabWrapperElement.querySelectorAll(
    '.main-product__tab'
  );
  tablinks.forEach(link => {
    link.classList.remove('active');
  });
  function scrolltoCenter(container, element) {
    var containerRect = container.getBoundingClientRect();
    var elementRect = element.getBoundingClientRect();
    var offset = elementRect.left - containerRect.left - (containerRect.width / 2) + (elementRect.width / 2);
    container.scrollBy({ left: offset, behavior: 'smooth' });
     if (!element.nextElementSibling) {
        document.querySelector('.main-product__tabs-wrapper .scroller-button .next').classList.add('disabled');
      }else{
        document.querySelector('.main-product__tabs-wrapper .scroller-button .next').classList.remove('disabled');
      }
      if (!element.previousElementSibling) {
        document.querySelector('.main-product__tabs-wrapper .scroller-button .previous').classList.add('disabled');
      }else{
        document.querySelector('.main-product__tabs-wrapper .scroller-button .previous').classList.remove('disabled');
      }
  }
  // Show the current tab and add the 'active' class to the button that opened the tab
  const currentTabContent = tabWrapperElement.querySelector(
    `#${tabName}`
  );
  if (currentTabContent) {
    var wrapper = document.querySelector('.main-product__tabs');
    currentTabContent.style.display = 'block';
    if (evt.currentTarget) {
      evt.currentTarget.classList.add('active');
      scrolltoCenter(wrapper, evt.currentTarget);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  function simulateClick(element) {
    const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    element.dispatchEvent(event);
  }

  // Get all the wrapper elements for each instance
  const tabWrappers = document.querySelectorAll(
    '.main-product__tabs-wrapper'
  );

  // Loop through each instance to find and click the default open tab
  tabWrappers.forEach(wrapper => {
    // get the wrapperID only if it exists
    const wrapperID = wrapper.getAttribute('id');
    if (!wrapperID) return;

    // get all the tabs marked as default open for every instance
    const defaultOpenTabs = wrapper.querySelectorAll(
      '.main-product__tab[data-default-open]'
    );

    // Loop through each default open tab and click it
    defaultOpenTabs.forEach(tabToClick => {
      simulateClick(tabToClick);
    });
  });

  var tabsContainer = document.querySelector('.main-product__tabs');
  var contentContainer = document.querySelector('.tab-content-wrapper'); 
  if (tabsContainer) {
    var firstTab = tabsContainer.firstElementChild;
    if (firstTab) {
      firstTab.classList.add('active');
    }
  }
  if (contentContainer) {
    var firstTab = contentContainer.firstElementChild;
    if (firstTab) {
      firstTab.style.display='block';
    }
  }

  var activeTab = document.querySelector('.main-product__tab.active');
  if (activeTab && !activeTab.previousElementSibling) {
    document.querySelector('.main-product__tabs-wrapper .scroller-button .previous').classList.add('disabled');
  }
  if (activeTab && !activeTab.nextElementSibling) {
    document.querySelector('.scroller-button').style.display='none';
  }

  document.querySelector('.main-product__tabs-wrapper .scroller-button .previous').addEventListener('click', function() {
    var activeTab = document.querySelector('.main-product__tab.active');
    var wrapper = document.querySelector('.main-product__tabs');
    if (activeTab && activeTab.previousElementSibling) {
      activeTab.previousElementSibling.click();
      // scrolltoCenter(wrapper, activeTab.previousElementSibling);
    }
  });
  
  document.querySelector('.main-product__tabs-wrapper .scroller-button .next').addEventListener('click', function() {
    var activeTab = document.querySelector('.main-product__tab.active');
    var wrapper = document.querySelector('.main-product__tabs');
    if (activeTab && activeTab.nextElementSibling) {
      activeTab.nextElementSibling.click();
      // scrolltoCenter(wrapper, activeTab.nextElementSibling);
    }
  });
});
